<template>
  <div class="modal fade" id="quoteSuccess" role="dialog">
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-content portrait-content">
        <div class="modal-head d-flex">
          <img src="@/assets/images/done.png" class="tick border-0 position-relative mt-3" />
        </div>
        <div class="modal-body text-center pb-0 pt-3 position-relative">
          <p class="text-center portrait-body">Your quote has been successfully shared at</p>
          <p class="font-weight-bold text-center">name@sample.com</p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center d-flex justify-content-center mt-1 mb-4 ">
          <button type="button" class="btn bgc-btn-primary w-25" data-dismiss="modal" id="quote-success-done">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuoteSuccessModal"
};
</script>

<style scoped>

.modal-head{
  -ms-flex-negative:0;
  flex-shrink:0;
  margin: 28px 5px 12px 5px;
  justify-content:space-between;
}
.modal-body {
  overflow-y: hidden;
}
.btn:hover {
  color: #ffffff;
}
.tick {
  color: white;
  width: 50px;
  height: 50px;
  left: 46%;
}
@media (min-width: 375px) {
  .portrait-body {
    width: 103%;
  } 
}
@media (min-width: 360px) {
  .portrait-body {
    width: 108%;
  } 
}
@media all and (device-width: 768px) and (device-height: 1024px) {
  .portrait-content {
    width: 100%;
  } 
}
</style>